webpackJsonp([35783957827783],{

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var combineHeaders = function combineHeaders() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.keys(params).map(function (key) {
	    return key + '=' + encodeURIComponent(params[key]);
	  }).join('&');
	};
	
	var createContactLink = function createContactLink(tel, sms, facetime, email, headers) {
	  var link = void 0;
	  if (email) {
	    link = 'mailto:' + email;
	    if (headers) {
	      link += '?' + combineHeaders(headers);
	    }
	  } else if (tel) {
	    link = 'tel:' + tel;
	  } else if (sms) {
	    link = 'sms:' + sms;
	  } else if (facetime) {
	    link = 'facetime:' + facetime;
	  }
	  return link;
	};
	
	var Obfuscate = function (_Component) {
	  _inherits(Obfuscate, _Component);
	
	  function Obfuscate(props) {
	    _classCallCheck(this, Obfuscate);
	
	    var _this = _possibleConstructorReturn(this, (Obfuscate.__proto__ || Object.getPrototypeOf(Obfuscate)).call(this, props));
	
	    _this.state = {
	      humanInteraction: false
	    };
	    return _this;
	  }
	
	  _createClass(Obfuscate, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props,
	          tel = _props.tel,
	          sms = _props.sms,
	          facetime = _props.facetime,
	          email = _props.email,
	          obfuscate = _props.obfuscate,
	          headers = _props.headers,
	          children = _props.children,
	          others = _objectWithoutProperties(_props, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          href: createContactLink(tel, sms, facetime, email, headers)
	        }, others),
	        children || tel || sms || facetime || email
	      );
	    }
	  }, {
	    key: 'reverse',
	    value: function reverse(s) {
	      return s.split('').reverse().join('');
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          tel = _props2.tel,
	          sms = _props2.sms,
	          facetime = _props2.facetime,
	          email = _props2.email,
	          obfuscate = _props2.obfuscate,
	          headers = _props2.headers,
	          children = _props2.children,
	          style = _props2.style,
	          linkText = _props2.linkText,
	          others = _objectWithoutProperties(_props2, ['tel', 'sms', 'facetime', 'email', 'obfuscate', 'headers', 'children', 'style', 'linkText']);
	
	      var obsStyle = this.state.humanInteraction === true || children ? _extends({}, style || {}, {
	        unicodeBidi: 'bidi-override',
	        direction: 'ltr'
	      }) : _extends({}, style || {}, {
	        unicodeBidi: 'bidi-override',
	        direction: 'rtl'
	      });
	
	      var link = function link(state) {
	        return _this2.state.humanInteraction === true ? children || tel || sms || facetime || email : children || _this2.reverse(tel || sms || facetime || email).replace('(', ')').replace(')', '(');
	      };
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          onClick: this.handleClick.bind(this),
	          onFocus: this.handleCopiability.bind(this),
	          onMouseOver: this.handleCopiability.bind(this),
	          onContextMenu: this.handleCopiability.bind(this),
	          href: linkText || 'obfuscated'
	        }, others, {
	          style: obsStyle
	        }),
	        link()
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props,
	          tel = _props3.tel,
	          sms = _props3.sms,
	          facetime = _props3.facetime,
	          email = _props3.email,
	          headers = _props3.headers;
	
	      window.location.href = createContactLink(tel, sms, facetime, email, headers);
	    }
	  }, {
	    key: 'handleCopiability',
	    value: function handleCopiability() {
	      this.setState(function (state) {
	        return _extends({}, state, {
	          humanInteraction: true
	        });
	      });
	    }
	  }]);
	
	  return Obfuscate;
	}(_react.Component);
	
	Obfuscate.propTypes = {
	  children: _propTypes.node,
	  tel: _propTypes.string,
	  sms: _propTypes.string,
	  facetime: _propTypes.string,
	  email: _propTypes.string,
	  headers: _propTypes.object,
	  obfuscate: _propTypes.bool,
	  style: _propTypes.object,
	  linkText: _propTypes.string
	};
	
	Obfuscate.defaultProps = {
	  obfuscate: true
	};
	
	exports.default = Obfuscate;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(38);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Nav = __webpack_require__(37);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _typography = __webpack_require__(17);
	
	var _reactObfuscate = __webpack_require__(182);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import Bio from '../components/Bio/Bio'
	
	
	//import myutils from '../utils/myutils'
	
	var MyResume = function (_React$Component) {
	  _inherits(MyResume, _React$Component);
	
	  function MyResume() {
	    _classCallCheck(this, MyResume);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MyResume.prototype.render = function render() {
	    var moment = __webpack_require__(35);
	    var now = moment(new Date());
	    var r = __webpack_require__(100);
	    var config = __webpack_require__(12);
	    //const { data } = this.props
	    //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
	    var d = {
	      title: config.siteTitle,
	      description: config.siteDescription,
	      image: config.siteImage,
	      url: config.siteUrl,
	      keywords: config.resumeKeywords,
	      datePublished: "2018-07-01",
	      dateUpdated: now.format("YYYY-MM-DD")
	    };
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          marginTop: (0, _typography.rhythm)(1 / 4)
	        }
	      },
	      _react2.default.createElement(_Seo2.default, { data: d, pageType: 'resume' }),
	      _react2.default.createElement(_Nav2.default, null),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginBottom: 0,
	            display: 'flex',
	            justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(
	          'h1',
	          { style: {
	              marginTop: '1rem'
	            } },
	          ' ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            ' ',
	            r['my_name'].toUpperCase()
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              justifyContent: 'center',
	              flexDirection: 'column',
	              fontSize: '0.8rem'
	            }
	          },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                marginBottom: '0px'
	              }
	            },
	            'Phone: ',
	            _react2.default.createElement(_reactObfuscate2.default, { tel: r['mobile'] })
	          ),
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                marginBottom: '0px'
	              }
	            },
	            'Email: ',
	            _react2.default.createElement(_reactObfuscate2.default, { email: r['email'] })
	          ),
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                marginBottom: '0px'
	              }
	            },
	            'Website: ',
	            _react2.default.createElement(
	              'a',
	              { href: '//www.chetanarya.com' },
	              'www.chetanarya.com'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(MySimpleList, { listTitle: 'Summary', list: r.headlines }),
	      _react2.default.createElement(JobIndex, { jobs: r.jobs }),
	      _react2.default.createElement(MySimpleList, { listTitle: 'Technical Skills', list: r.techSkills }),
	      _react2.default.createElement(Award, { awards: r.awards }),
	      _react2.default.createElement(Education, { educations: r.education }),
	      _react2.default.createElement(SocialLinksIndex, { contactPoints: r.contact_points }),
	      _react2.default.createElement(Copyright, { copyright: r.copyright })
	    );
	  };
	
	  return MyResume;
	}(_react2.default.Component);
	
	var SocialLinksIndex = function (_React$Component2) {
	  _inherits(SocialLinksIndex, _React$Component2);
	
	  function SocialLinksIndex() {
	    _classCallCheck(this, SocialLinksIndex);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  SocialLinksIndex.prototype.render = function render() {
	    var contactPoints = this.props.contactPoints;
	    var j = contactPoints.map(function (cp) {
	      return _react2.default.createElement(
	        'li',
	        {
	          key: cp.name,
	          style: {
	            marginBottom: 0,
	            fontSize: '0.8rem'
	          }
	        },
	        cp.name,
	        ' @ ',
	        _react2.default.createElement(
	          'a',
	          { href: cp.url },
	          ' ',
	          cp.url
	        )
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'flex-start'
	          }
	        },
	        _react2.default.createElement(
	          'h3',
	          {
	            style: {
	              // textDecoration: 'underline',
	              marginTop: '1rem'
	            }
	          },
	          'Social Locators'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            //...scale(0.1),
	            fontWeight: 'lighter'
	          }
	        },
	        _react2.default.createElement(
	          'ol',
	          null,
	          j
	        )
	      )
	    );
	  };
	
	  return SocialLinksIndex;
	}(_react2.default.Component);
	
	var MySimpleList = function (_React$Component3) {
	  _inherits(MySimpleList, _React$Component3);
	
	  function MySimpleList() {
	    _classCallCheck(this, MySimpleList);
	
	    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	  }
	
	  MySimpleList.prototype.render = function render() {
	    var list = this.props.list;
	    var listTitle = this.props.listTitle;
	    var j = list.map(function (hl) {
	      return _react2.default.createElement(
	        'li',
	        {
	          key: hl,
	          style: {
	            marginBottom: 0,
	            fontSize: '0.8rem'
	          }
	        },
	        hl
	      );
	    });
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'flex-start'
	          }
	        },
	        _react2.default.createElement(
	          'h3',
	          {
	            style: {
	              //textDecoration: 'underline',
	              marginTop: '1rem'
	            }
	          },
	          listTitle
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            //...scale(0.1),
	            fontWeight: 'lighter'
	          }
	        },
	        _react2.default.createElement(
	          'ol',
	          {
	            style: {
	              // listStyle: 'none',
	            }
	          },
	          j
	        )
	      )
	    );
	  };
	
	  return MySimpleList;
	}(_react2.default.Component);
	
	var JobIndex = function (_React$Component4) {
	  _inherits(JobIndex, _React$Component4);
	
	  function JobIndex() {
	    _classCallCheck(this, JobIndex);
	
	    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
	  }
	
	  JobIndex.prototype.render = function render() {
	    var jobs = this.props.jobs;
	    var j = jobs.map(function (job) {
	      return _react2.default.createElement(Job, { key: job.title, job: job });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'flex-start'
	          }
	        },
	        _react2.default.createElement(
	          'h3',
	          {
	            style: {
	              // textDecoration: 'underline',
	              marginTop: '1rem'
	            }
	          },
	          'Employment History'
	        )
	      ),
	      j
	    );
	  };
	
	  return JobIndex;
	}(_react2.default.Component);
	
	var Copyright = function (_React$Component5) {
	  _inherits(Copyright, _React$Component5);
	
	  function Copyright() {
	    _classCallCheck(this, Copyright);
	
	    return _possibleConstructorReturn(this, _React$Component5.apply(this, arguments));
	  }
	
	  Copyright.prototype.render = function render() {
	    var cr = this.props.copyright;
	
	    var dangerousCR = { __html: '<p style="margin-bottom:0px;">' + cr + '</p>' };
	    return _react2.default.createElement('div', { dangerouslySetInnerHTML: dangerousCR, style: {
	        fontSize: '0.6rem'
	      } });
	  };
	
	  return Copyright;
	}(_react2.default.Component);
	
	var Job = function (_React$Component6) {
	  _inherits(Job, _React$Component6);
	
	  function Job() {
	    _classCallCheck(this, Job);
	
	    return _possibleConstructorReturn(this, _React$Component6.apply(this, arguments));
	  }
	
	  Job.prototype.render = function render() {
	    var job = this.props.job;
	    var j = job.roles.map(function (role) {
	      return '<li style="font-size: 0.8rem; margin-bottom: 0px;">' + role + '</li>';
	    }).join('');
	    //console.log(j)
	    var dangerousJ = { __html: j
	      //debugger
	    };return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginTop: '0px'
	          }
	        },
	        _react2.default.createElement(
	          'h6',
	          {
	            style: {
	              marginTop: '1rem'
	            }
	          },
	          _react2.default.createElement(
	            'strong',
	            null,
	            job.title
	          ),
	          ' at ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            job.org,
	            ', ',
	            job.location
	          ),
	          ' (',
	          _react2.default.createElement(
	            'strong',
	            null,
	            ' ',
	            job.dates,
	            ' '
	          ),
	          ')'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            //...scale(0.1),
	            fontWeight: 'lighter'
	          }
	        },
	        _react2.default.createElement('ol', { dangerouslySetInnerHTML: dangerousJ })
	      )
	    );
	  };
	
	  return Job;
	}(_react2.default.Component);
	
	var Education = function (_React$Component7) {
	  _inherits(Education, _React$Component7);
	
	  function Education() {
	    _classCallCheck(this, Education);
	
	    return _possibleConstructorReturn(this, _React$Component7.apply(this, arguments));
	  }
	
	  Education.prototype.render = function render() {
	    var educations = this.props.educations;
	    var j = educations.map(function (education) {
	      return _react2.default.createElement(
	        'ol',
	        {
	          key: education,
	          style: {
	            marginBottom: 0,
	            fontSize: '0.8rem',
	            marginLeft: 0
	          }
	        },
	        education
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'flex-start'
	          }
	        },
	        _react2.default.createElement(
	          'h3',
	          {
	            style: {
	              marginTop: '1rem'
	            }
	          },
	          'Education'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            fontWeight: 'lighter'
	          }
	        },
	        j
	      )
	    );
	  };
	
	  return Education;
	}(_react2.default.Component);
	
	var Award = function (_React$Component8) {
	  _inherits(Award, _React$Component8);
	
	  function Award() {
	    _classCallCheck(this, Award);
	
	    return _possibleConstructorReturn(this, _React$Component8.apply(this, arguments));
	  }
	
	  Award.prototype.render = function render() {
	    var awards = this.props.awards;
	    var j = awards.map(function (award) {
	      return _react2.default.createElement(
	        'li',
	        {
	          key: award,
	          style: {
	            marginBottom: 0,
	            fontSize: '0.8rem'
	          }
	        },
	        award
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'flex-start'
	          }
	        },
	        _react2.default.createElement(
	          'h3',
	          {
	            style: {
	              // textDecoration: 'underline',
	              marginTop: '1rem'
	            }
	          },
	          'Awards'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            //...scale(0.1),
	            fontWeight: 'lighter'
	          }
	        },
	        _react2.default.createElement(
	          'ol',
	          null,
	          j
	        )
	      )
	    );
	  };
	
	  return Award;
	}(_react2.default.Component);
	
	exports.default = MyResume;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ad50fa6e5df02cfacc0b.js